export const ExternalInvitationKind = {
	EVENT: "event",
	MEETING: "meeting",
} as const;
export type ExternalInvitationKind = (typeof ExternalInvitationKind)[keyof typeof ExternalInvitationKind];

export const ExternalInvitationAction = {
	ACCEPTED: "accepted",
	DECLINED: "declined",
} as const;
export type ExternalInvitationAction = (typeof ExternalInvitationAction)[keyof typeof ExternalInvitationAction];
